module.exports = __webpack_public_path__ + "img/申报流程.a5010bce.png";